// import React, { useState }  from "react"
// import axios from "axios";
// import Swal from 'sweetalert2';
// import { useDispatch , useSelector } from 'react-redux'; 
// import { Helmet } from 'react-helmet-async';
// import { Container  } from "@mui/material";
// import { useNavigate } from "react-router-dom"; 
// import 'react-quill/dist/quill.snow.css'; 
// import "../App.css"
// import { Url } from "../url/url" ;
// import { categorydata } from '../redux/slice/category'
// import { subcategorydata } from '../redux/slice/subcategory'



 
 

// const AddCategory = () => { 
//     const categoryalldata = useSelector(store => store.category.data)
//     const [formValue, setFormValue] = useState({});
//     const [fileValue, setFileValue] = useState({})
//     const [statusValue, setStatusValue] = useState("1");
//     const [subCategoryData, setSubCategoryData] = useState({});
//     const [catLoading, setCatLoading] = useState(false)
//     const [subCatLoading, setSubCatLoading] = useState(false)

//     const dispatch = useDispatch()
//     const navigate = useNavigate()
//     const filehandle = (e)=>{
//         const file = e.target.files[0]
//         const name = e.target.name
//         setFileValue({...fileValue, [name]:file})
//     }
//     const formhandle = (e)=>{
//         const name = e.target.name
//         const value = e.target.value 
//         const lowervalue = value.toLowerCase()
//         setFormValue({...formValue, [name]:lowervalue})
//     }
//     const submit = async (e)=>{
//         e.preventDefault();
//         setCatLoading(true)
//         const data = {...formValue} 
//         const formData = new FormData()
//         formData.append("category", data.category)  
//         try {
//             await axios.post(`${Url}/category`, formData).then((e)=>{
//                 Swal.fire({
//                     position: 'top-end',
//                     icon: 'success',
//                     title: 'Accout Create Success',
//                     showConfirmButton: false,
//                     timer: 1500
//                   })
//                   setFormValue({})
//                   setCatLoading(false)
//                   dispatch(categorydata())
//                   navigate("/dashboard/category")
//             })
//         } catch (error) {
//             setCatLoading(false)
//             console.log(error);
//         }
//         setCatLoading(false)
//     }
//     const subcategoryformhandle = (e)=>{
//         const name = e.target.name
//         const value = e.target.value 
//         const lowervalue = value.toLowerCase()
//         setSubCategoryData({...subCategoryData, [name]:lowervalue})
//     }
//     const subCategorySubmit = async (e)=>{
//         e.preventDefault();
//         setSubCatLoading(true)
//         const data = {...subCategoryData, "status" : statusValue} 
//         try {
//             const {category, subcategory, status} = data
//             if(category && subcategory && status){
//             await axios.post(`${Url}/subcategory`, data).then((e)=>{
//                 Swal.fire({
//                     position: 'top-end',
//                     icon: 'success',
//                     title: 'Accout Create Success',
//                     showConfirmButton: false,
//                     timer: 1500
//                   })
//                   setSubCatLoading(false)
//                   dispatch(subcategorydata())
//                   navigate("/dashboard/category")
//             })
//             }
//             else{
//                 setSubCatLoading(false)
//                 Swal.fire('All fields are required')
//             }
//         } catch (error) {
//             setSubCatLoading(false)
//             console.log(error);
//             console.log("subcategory not create");
//         }
//     }
    


//   return (
//     <>
//     <Helmet>
//         <title> Add Category </title>
//     </Helmet>
 

//         <Container className="mb-5 card px-3 py-4">
//             <div className="mb-4 text-primary">
//                 <h2 className="text-capitalize">Add new Category</h2>
//             </div>
//             <div className="">
//                 <form action="">
//                     <div className="row align-items-end">
                        
//                         <div className="col-lg-4 col-12 mb-2">
//                             <div className="form-group">
//                                 <p className="mb-0 fw-bold">Image</p>
//                                 <input type="file" name="categoryimage" onChange={e=>filehandle(e)} className="form-control" />
//                             </div>
//                         </div>
//                         <div className="col-lg-4 col-12 mb-2">
//                             <div className="form-group">
//                                 <p className="mb-0 fw-bold">Category Name</p>
//                                 <input type="text" name="category" value={formValue.category} onChange={e=>formhandle(e)} className="form-control" />
//                             </div>
//                         </div>
//                         <div className="col-lg-4 col-12 mb-2 ">
//                             <button className="btn btn-primary" disabled={catLoading} onClick={e=>submit(e)}>{catLoading? "saving..." : "Save"}</button>
//                         </div>
//                     </div>
//                 </form>
//             </div>
//         </Container>
//         <Container className="mb-5 card px-3 py-4">
//             <div className="mb-4 text-primary">
//                 <h2 className="text-capitalize">Add new Sub Category</h2>
//             </div>
//             <div className="">
//                 <form action="">
//                     <div className="row align-items-end">
                        
//                         <div className="col-lg-3 col-md-6 col-12 mb-2">
//                             <div className="form-group">
//                                 <p className="mb-0 fw-bold">Choose Category</p>
//                                 <select name="category" id="" className="form-select" onChange={e => subcategoryformhandle(e)}>
//                                     <option disabled selected>Select</option>
//                                     {categoryalldata.map((value, i)=>{
//                                         return(
//                                             <option value={value.category} key={i}>{value.category}</option>
//                                         )
//                                         })
//                                     } 
//                                 </select>
//                             </div>
//                         </div>
//                         <div className="col-lg-3 col-md-6 col-12 mb-2">
//                             <div className="form-group">
//                                 <p className="mb-0 fw-bold">Sub Category Name</p>
//                                 <input type="text" className="form-control" name="subcategory" onChange={e => subcategoryformhandle(e)} />
//                             </div>
//                         </div>
//                         <div className="col-lg-3 col-md-6 col-12 mb-2">
//                             <div className="form-group">
//                                 <p className="mb-0 fw-bold">Status</p>
//                                 <select name="status" id="" onChange={ e=>setStatusValue(e.target.value)} className="form-select">
//                                     <option  defaultValue value={1}>Active</option> 
//                                     <option   value={0}>Inactive</option> 
//                                 </select>
//                             </div>
//                         </div>
//                         <div className="col-lg-3 col-md-6 col-12 mb-2 ">
//                             <button className="btn btn-primary" disabled={subCatLoading} onClick={ e => subCategorySubmit(e)}>
//                             {subCatLoading? "saving..." : "Save"}
//                             </button>
//                         </div>
//                     </div>
//                 </form>
//             </div>
//         </Container>
//     </>
//   )
// }

// export default AddCategory














import React, { useEffect, useState } from "react"
import axios from "axios";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';
import { Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import "../App.css"
import { Url } from "../url/url";
import { maincategorydata } from '../redux/slice/Maincategory'
import { categorydata } from '../redux/slice/category'
import { subcategorydata } from '../redux/slice/subcategory'


const AddCategory = () => {
    const mainCategoryAllData = useSelector(store => store.maincategory.data)
    const categoryalldata = useSelector(store => store.category.data)

    const dispatch = useDispatch()
    const navigate = useNavigate()

    // ---------- Main Category state ----------
    const [mainCategoryValue, setMainCategoryValue] = useState("")
    const [mainCatLoading, setMainCatLoading] = useState(false)

    // ---------- Category state ----------
    const [categoryFormValue, setCategoryFormValue] = useState({})
    const [catLoading, setCatLoading] = useState(false)

    // ---------- Subcategory state ----------
    const [subCategoryData, setSubCategoryData] = useState({})
    const [statusValue, setStatusValue] = useState("1")
    const [subCatLoading, setSubCatLoading] = useState(false)

    // Categories sirf selected Main Category ke hisab se dikhengi (dropdown filter)
    const [filteredCategories, setFilteredCategories] = useState([])

    useEffect(() => {
        dispatch(maincategorydata())
        dispatch(categorydata())
        dispatch(subcategorydata())
    }, [dispatch])

    // ---------- Main Category submit ----------
    const mainCategorySubmit = async (e) => {
        e.preventDefault();
        if (!mainCategoryValue) {
            Swal.fire('Main category name is required')
            return
        }
        setMainCatLoading(true)
        try {
            await axios.post(`${Url}/maincategory/create`, { mainCategory: mainCategoryValue })
            Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Main Category Created',
                showConfirmButton: false,
                timer: 1500
            })
            setMainCategoryValue("")
            dispatch(maincategorydata())
        } catch (error) {
            console.log(error)
            Swal.fire('Something went wrong', error?.response?.data?.message || error.message, 'error')
        }
        setMainCatLoading(false)
    }

    // ---------- Category form handlers ----------
    const categoryFormHandle = (e) => {
        const { name, value } = e.target
        const finalValue = name === "category" ? value.toLowerCase() : value
        setCategoryFormValue({ ...categoryFormValue, [name]: finalValue })
    }

    const categorySubmit = async (e) => {
        e.preventDefault();
        const { mainCategory, category } = categoryFormValue
        if (!mainCategory || !category) {
            Swal.fire('All fields are required')
            return
        }
        setCatLoading(true)
        try {
            await axios.post(`${Url}/category/create`, { mainCategory, category })
            Swal.fire({
                position: 'top-end',
                icon: 'success',
                title: 'Category Created',
                showConfirmButton: false,
                timer: 1500
            })
            setCategoryFormValue({})
            dispatch(categorydata())
            navigate("/dashboard/category")
        } catch (error) {
            console.log(error)
            Swal.fire('Something went wrong', error?.response?.data?.message || error.message, 'error')
        }
        setCatLoading(false)
    }

    // ---------- Subcategory form handlers ----------
    const subcategoryFormHandle = (e) => {
        const { name, value } = e.target

        if (name === "category") {
            // category select hote hi uski _id store karo (ObjectId chahiye, naam nahi)
            setSubCategoryData({ ...subCategoryData, category: value })
            return
        }

        const finalValue = name === "subcategory" ? value.toLowerCase() : value
        setSubCategoryData({ ...subCategoryData, [name]: finalValue })
    }

    // Main Category select hone par, sirf usi ke andar ki categories dikhao
    const onMainCategorySelectForSub = (e) => {
        const mainCatId = e.target.value
        setSubCategoryData({ ...subCategoryData, mainCategoryFilter: mainCatId, category: "" })
        const filtered = categoryalldata.filter(cat => {
            const catMainId = cat.mainCategory?._id || cat.mainCategory
            return catMainId === mainCatId
        })
        setFilteredCategories(filtered)
    }

    const subCategorySubmit = async (e) => {
        e.preventDefault();
        setSubCatLoading(true)
        const data = {
            category: subCategoryData.category,
            subcategory: subCategoryData.subcategory,
            status: statusValue
        }
        try {
            const { category, subcategory, status } = data
            if (category && subcategory && status) {
                await axios.post(`${Url}/subcategory/create`, data)
                Swal.fire({
                    position: 'top-end',
                    icon: 'success',
                    title: 'Subcategory Created',
                    showConfirmButton: false,
                    timer: 1500
                })
                setSubCategoryData({})
                setFilteredCategories([])
                dispatch(subcategorydata())
                navigate("/dashboard/category")
            } else {
                Swal.fire('All fields are required')
            }
        } catch (error) {
            console.log(error)
            Swal.fire('Something went wrong', error?.response?.data?.message || error.message, 'error')
        }
        setSubCatLoading(false)
    }

    return (
        <>
            <Helmet>
                <title> Add Category </title>
            </Helmet>

            {/* ---------------- MAIN CATEGORY ---------------- */}
            <Container className="mb-5 card px-3 py-4">
                <div className="mb-4 text-primary">
                    <h2 className="text-capitalize">Add New Main Category</h2>
                    <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
                        e.g. "Shop for Pets", "Shop for Human"
                    </p>
                </div>
                <form>
                    <div className="row align-items-end">
                        <div className="col-lg-6 col-12 mb-2">
                            <div className="form-group">
                                <p className="mb-0 fw-bold">Main Category Name</p>
                                <input
                                    type="text"
                                    name="mainCategory"
                                    value={mainCategoryValue}
                                    onChange={e => setMainCategoryValue(e.target.value)}
                                    className="form-control"
                                    placeholder="Shop for Pets"
                                />
                            </div>
                        </div>
                        <div className="col-lg-3 col-12 mb-2">
                            <button
                                type="button"
                                className="btn btn-primary"
                                disabled={mainCatLoading}
                                onClick={mainCategorySubmit}
                            >
                                {mainCatLoading ? "saving..." : "Save"}
                            </button>
                        </div>
                    </div>
                </form>

                {/* Existing main categories preview */}
                {mainCategoryAllData?.length > 0 && (
                    <div className="mt-3">
                        <p className="mb-1 fw-bold">Existing Main Categories:</p>
                        <ul className="mb-0">
                            {mainCategoryAllData.map((m) => (
                                <li key={m._id} className="text-capitalize">{m.mainCategory}</li>
                            ))}
                        </ul>
                    </div>
                )}
            </Container>

            {/* ---------------- CATEGORY ---------------- */}
            <Container className="mb-5 card px-3 py-4">
                <div className="mb-4 text-primary">
                    <h2 className="text-capitalize">Add New Category</h2>
                    <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
                        e.g. "Dog", "Cat" under "Shop for Pets"; "Furniture" under "Shop for Human"
                    </p>
                </div>
                <form>
                    <div className="row align-items-end">
                        <div className="col-lg-4 col-12 mb-2">
                            <div className="form-group">
                                <p className="mb-0 fw-bold">Choose Main Category</p>
                                <select
                                    name="mainCategory"
                                    className="form-select"
                                    value={categoryFormValue.mainCategory || ""}
                                    onChange={categoryFormHandle}
                                >
                                    <option value="" disabled>Select</option>
                                    {mainCategoryAllData?.map((m) => (
                                        <option value={m._id} key={m._id} className="text-capitalize">
                                            {m.mainCategory}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 mb-2">
                            <div className="form-group">
                                <p className="mb-0 fw-bold">Category Name</p>
                                <input
                                    type="text"
                                    name="category"
                                    value={categoryFormValue.category || ""}
                                    onChange={categoryFormHandle}
                                    className="form-control"
                                    placeholder="Dog"
                                />
                            </div>
                        </div>
                        <div className="col-lg-4 col-12 mb-2">
                            <button
                                type="button"
                                className="btn btn-primary"
                                disabled={catLoading}
                                onClick={categorySubmit}
                            >
                                {catLoading ? "saving..." : "Save"}
                            </button>
                        </div>
                    </div>
                </form>
            </Container>

            {/* ---------------- SUBCATEGORY ---------------- */}
            <Container className="mb-5 card px-3 py-4">
                <div className="mb-4 text-primary">
                    <h2 className="text-capitalize">Add New Sub Category</h2>
                    <p className="text-muted mb-0" style={{ fontSize: "0.9rem" }}>
                        e.g. "Food", "Toys" under "Dog"
                    </p>
                </div>
                <form>
                    <div className="row align-items-end">
                        <div className="col-lg-3 col-md-6 col-12 mb-2">
                            <div className="form-group">
                                <p className="mb-0 fw-bold">Choose Main Category</p>
                                <select
                                    name="mainCategoryFilter"
                                    className="form-select"
                                    value={subCategoryData.mainCategoryFilter || ""}
                                    onChange={onMainCategorySelectForSub}
                                >
                                    <option value="" disabled>Select</option>
                                    {mainCategoryAllData?.map((m) => (
                                        <option value={m._id} key={m._id} className="text-capitalize">
                                            {m.mainCategory}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12 mb-2">
                            <div className="form-group">
                                <p className="mb-0 fw-bold">Choose Category</p>
                                <select
                                    name="category"
                                    className="form-select"
                                    value={subCategoryData.category || ""}
                                    onChange={subcategoryFormHandle}
                                    disabled={!subCategoryData.mainCategoryFilter}
                                >
                                    <option value="" disabled>Select</option>
                                    {filteredCategories.map((cat) => (
                                        <option value={cat._id} key={cat._id} className="text-capitalize">
                                            {cat.category}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12 mb-2">
                            <div className="form-group">
                                <p className="mb-0 fw-bold">Sub Category Name</p>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="subcategory"
                                    value={subCategoryData.subcategory || ""}
                                    onChange={subcategoryFormHandle}
                                    placeholder="Food"
                                />
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6 col-12 mb-2">
                            <div className="form-group">
                                <p className="mb-0 fw-bold">Status</p>
                                <select
                                    name="status"
                                    onChange={e => setStatusValue(e.target.value)}
                                    className="form-select"
                                    value={statusValue}
                                >
                                    <option value="1">Active</option>
                                    <option value="0">Inactive</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-12 mt-2">
                            <button
                                type="button"
                                className="btn btn-primary"
                                disabled={subCatLoading}
                                onClick={subCategorySubmit}
                            >
                                {subCatLoading ? "saving..." : "Save"}
                            </button>
                        </div>
                    </div>
                </form>
            </Container>
        </>
    )
}

export default AddCategory